module.exports = __webpack_public_path__ + "img/AnyVanAdviceLogo-White.3d0d88e.svg";